// Components==============
import React, { useContext } from 'react';
import { AudioExerciseContext } from 'screens/AudioExercise/AudioExercise';
import { ClapSoundExerciseContext } from '../../ClapSoundExercise';
import Bell from './Bell/Bell';
import Buttons from './Buttons/Buttons';
import './Exercise.module.scss';
// =========================

export type BellStatus =
    | 'stale'
    | 'wrong'
    | 'right'
    | 'incorrectRight'
    | 'incorrectWrong'
    | 'initial';

export default function Exercise({
    currentWord,
}: {
    currentWord?: ExerciseTypes;
}) {
    const { shuffledExercise, current, answers } = useContext(
        ClapSoundExerciseContext
    );

    const { background } = useContext(AudioExerciseContext);

    return (
        <div styleName="wrapper">
            <Buttons word={currentWord}>
                {current > 0 &&
                    shuffledExercise
                        .filter((w, i) =>
                            current === 0 ? i === 1 : i < current
                        )
                        .map((word, i) => (
                            <Bell
                                key={i}
                                status={answers[i] || 'initial'}
                                // Import from parent to prevent useParams unnecessary rerender bug
                                background={background}
                            />
                        ))}
                {current === 0 && (
                    <Bell key={0} status="stale" background={background} />
                )}
            </Buttons>
        </div>
    );
}
